import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CheckboxGroupFieldComponent} from "./checkbox-group-field.component";
import {CheckboxFieldModule} from "../checkbox-field/checkbox-field.module";
import {CollapsibleModule} from "../../../../component/collapsible/collapsible.module";
import {
    CollapsibleWithCheckboxModule
} from "../../../../component/collapsible-with-checkbox/collapsible-with-checkbox.module";
import {NotificationModule} from "../../../../component/notification/notification.module";
import { CapitalizeFirstLetterPipeModule } from "libraries/pipes/capitalize-first-letter/capitalize-first-letter.module";

@NgModule({
    declarations: [
        CheckboxGroupFieldComponent,
    ],
    exports: [
        CheckboxGroupFieldComponent,
    ],
    imports: [
        CommonModule,
        CheckboxFieldModule,
        CollapsibleModule,
        CollapsibleWithCheckboxModule,
        NotificationModule,
        CapitalizeFirstLetterPipeModule
    ]
})
export class CheckboxGroupFieldModule {
}
